var ezdia;
(function (ezdia) {
    var OPTIONS = {
        templateName: ezdia.templates.timer.template,
        container: 'body',
        customeEventType: 'timer:done'
    };
    function setOptions(options) {
        Object.assign(this, OPTIONS, options);
        if (!this.time && !this.date) {
            throw new Error('Timer configuration is missing.');
        }
        this.distance = getDistance.call(this);
    }
    function getDistance(time) {
        if (time === void 0) { time = this.time; }
        var now = new Date().getTime();
        var countDownTime = 0;
        if (this.date) {
            countDownTime = new Date(this.date).getTime();
        }
        else {
            countDownTime = now + time;
        }
        return countDownTime;
    }
    function getCurrentTimerValue(milliseconds) {
        var now = new Date().getTime();
        var diff = this.distance - now;
        var timeObj = null;
        if (milliseconds) {
            timeObj = diff;
        }
        else if (diff >= 0) {
            var days = Math.floor(diff / (1000 * 60 * 60 * 24));
            var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((diff % (1000 * 60)) / 1000);
            timeObj = {
                days: days,
                hours: ("0" + hours).slice(-2),
                minutes: ("0" + minutes).slice(-2),
                seconds: ("0" + seconds).slice(-2)
            };
        }
        return timeObj;
    }
    function updateTimer() {
        var now = getCurrentTimerValue.call(this);
        var markup = '';
        if (now) {
            markup = this.template(now);
        }
        else {
            this.clear();
            $(this).trigger(this.customeEventType);
            if (this.callback) {
                this.callback();
            }
        }
        this.dom.updateContainer.html(markup);
    }
    function renderInitialMarkup() {
        var id = $.ezdia.makeId();
        var markup = $('<div>', {
            id: id
        });
        this.dom.container.append(markup);
        this.dom.updateContainer = $("#" + id);
    }
    function domCache() {
        this.dom = {
            container: this.container instanceof $ ? this.container : $(this.container)
        };
    }
    function init(options) {
        setOptions.call(this, options);
        this.template = this.templateName;
        domCache.call(this);
        renderInitialMarkup.call(this);
    }
    function start() {
        this.interval = setInterval(updateTimer.bind(this), 1000);
    }
    function pause() {
        var time = this.getRemaningTime();
        this.distance = getDistance.call(this, time);
        clearInterval(this.interval);
    }
    function restart() {
        this.start();
    }
    function clear() {
        clearInterval(this.interval);
    }
    function getRemaningTime() {
        return getCurrentTimerValue.call(this, true);
    }
    var widgets;
    (function (widgets) {
        widgets.timer = {
            init: init,
            start: start,
            pause: pause,
            restart: restart,
            clear: clear,
            getRemaningTime: getRemaningTime
        };
    })(widgets = ezdia.widgets || (ezdia.widgets = {}));
})(ezdia || (ezdia = {}));
